/**
 *
 */
const setupHeaderSearch = () =>
{
	const toggle      = document.querySelector( 'header .search-toggle' );
	const container   = document.querySelector( 'header .search-container' );
	const form        = document.querySelector( 'header .search-form' );
	const searchInput = document.querySelector( 'header .search-field' );


	if (!(toggle instanceof HTMLButtonElement
		&& container instanceof HTMLElement
		&& searchInput instanceof HTMLInputElement
		&& form instanceof HTMLFormElement)) {
		return;
	}

	toggle.addEventListener( 'click', e =>
	{
		e.preventDefault();
		container.classList.toggle( 'expanded' );

		setTimeout( () =>
		{
			if (container.classList.contains( 'expanded' )) {
				searchInput.focus();
			}
		}, 500 );
	} );

	// close on outside click

	window.addEventListener( 'click', e =>
	{
		if (container instanceof HTMLElement && e.target instanceof Node) {
			if (container.classList.contains( 'expanded' )) {
				if (!container.contains( e.target )) {
					container.classList.toggle( 'expanded' );
				}
			}
		}
	} );

	// submit

	form.addEventListener( 'submit', e =>
	{
		const loading = container.querySelector( '.search-results-loading' );

		if (loading instanceof HTMLElement) {
			loading.classList.add( 'is-loading' );
		}
	} );
};


/**
 *
 */
export default setupHeaderSearch;